import { STORAGE_KEYS } from '@/config/tabsConfig';
import { LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar, Menu, Spin } from 'antd';
import React, { useCallback } from 'react';
import { useModel } from '@/context/AuthContext';
import { history } from '@/utils/navigation';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.module.less';

export interface GlobalHeaderRightProps {
  menu?: boolean;
}

/**
 * 退出登录，并且将当前的 url 保存
 */
export const loginOut = async () => {
  const location = window.location;
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get('redirect');

  // Clear authentication
  localStorage.removeItem('token');
  localStorage.removeItem('dashboard-latest-data');
  localStorage.removeItem('dashboard-last-fetch');
  localStorage.removeItem('turnstileToken');

  // Clear tab state on logout (keep settings, they're user preferences)
  // We keep pinned tabs as they represent user's workspace preference
  // But clear recent/unpinned tabs for a fresh start on next login
  try {
    const tabsState = localStorage.getItem(STORAGE_KEYS.TABS_STATE);
    if (tabsState) {
      const parsed = JSON.parse(tabsState);
      // Keep only pinned tabs, clear recent tabs
      const cleanedState = {
        ...parsed,
        recentTabs: [],
        tabHistories: {},
        activeTabKey: null,
      };
      localStorage.setItem(STORAGE_KEYS.TABS_STATE, JSON.stringify(cleanedState));
    }
  } catch (e) {
    // If parsing fails, just remove the entire state
    localStorage.removeItem(STORAGE_KEYS.TABS_STATE);
  }

  if (window.location.pathname !== '/login' && !redirect) {
    history.replace({
      pathname: '/login',
      search: new URLSearchParams({ redirect: pathname }).toString()
    });
  }
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu }) => {
  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick = useCallback(
    (event: { key: React.Key; keyPath: React.Key[]; item: React.ReactInstance; domEvent: React.MouseEvent<HTMLElement> }) => {
      const { key } = event;
      if (key === 'logout' && initialState) {
        setInitialState({ ...initialState, currentUser: undefined });
        loginOut();
        return;
      }
      history.push(`/account/${key}`);
    },
    [initialState, setInitialState]
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      {/* {menu && (
        <Menu.Item key="center">
          <UserOutlined />
          My Account
        </Menu.Item>
      )} */}
      {menu && (
        <Menu.Item key="settings">
          <SettingOutlined />
          Account Setting
        </Menu.Item>
      )}
      {menu && <Menu.Divider />}

      <Menu.Item key="logout">
        <LogoutOutlined />
        Logout
      </Menu.Item>

      <Menu.Divider />
      <Menu.Item key="version" disabled style={{ cursor: 'default', opacity: 0.6, fontSize: 12 }}>
        {BUILD_VERSION}
      </Menu.Item>
    </Menu>
  );
  return (
    <HeaderDropdown overlay={menuHeaderDropdown}>
      <span className={`${styles.action} ${styles.account}`}>
        {currentUser.avatar && <Avatar size="small" className={styles.avatar} src={currentUser.avatar} alt="avatar" />}
        <span className={`${styles.name} anticon`}>{currentUser.name}</span>
      </span>
    </HeaderDropdown>
  );
};

export default AvatarDropdown;
